import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    clientname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    eventdate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please provide the number of guests' }
      ]
    },
    theme: {
      validations: []
    },
    SiteName: {
      validations: []
    },
    reference: {
      validations: []
    },
    category: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'NAME/COMPANY:*',
            mapping: 'clientname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'PHONE NUMBER:*',
            mapping: 'telnumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'EMAIL:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'DATE OF EVENT:*',
            mapping: 'eventdate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'NUMBER OF GUESTS:*',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'EVENT TYPE:',
            options: [
              { label: 'Private Dining/Social', value: 'Private Dining/Social' },
              { label: 'Conference/ Seminar', value: 'Conference/ Seminar' },
              { label: 'Product Launch', value: 'Product Launch' },
              { label: 'Gala Dinner', value: 'Gala Dinner' },
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'VENUE/ADDRESS:',
            mapping: 'SiteName'
          }
        ]
      },
      {
        fields: [
          {
        type: 'multiple-choice',
        size: 'Medium',
        label: 'HOW DID YOU HEAR ABOUT US?',
        options: [
          { label: 'Google Search' , value: 'Google Search'},
          { label: 'Social Media (Instagram, Facebook, etc.)' , value: 'Social Media (Instagram, Facebook, etc.)'},
          { label: 'Referral from a Friend or Colleague' , value: 'Referral from a Friend or Colleague'},
          { label: 'Event or Exhibition' , value: 'Event or Exhibition'},
          { label: 'Returning Customer' , value: 'Returning Customer'},
          { label: 'Other' , value: 'Other'},          
        ],
        mapping: 'category'
      }
    ]
  },
  {
    fields: [
      {
            type: 'text-area',
            size: 'XLarge',
            label: 'ADDITIONAL INFORMATION:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Dish Catering and Events Contact Form',
    formId: '2024',
    clientKey: 'A1E2C638-F8A9-45BA-A4EE-4E3CA1DEC53B',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    submissionText: 'Thank you! Your request has been received. Our catering coordinator will reach out to you within 24 business hours.',
    redirectUrl: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};

export default FormStructure;
